import { combineReducers } from "@reduxjs/toolkit";
import balancesBySource from "./balances-by-source";

const balancesBySourceReducer = combineReducers({
  balancesBySource,
});

export default balancesBySourceReducer;
